import React from 'react';
import Loader from '../../../../components/common/loader';

const LoadingState: React.FC = () => (
  <Loader
    text={'Loading draft preview...'}
    mode={'determinate'}
    showHeaderFooter={false}
    speed={4.0}
  />
);

export default React.memo(LoadingState);
